// @flow
import * as React from 'react';
import styled from 'styled-components';

import { below } from '../../assets/css/media';
import colors from '../../assets/css/colors';

import {
	ModalContainer,
	ButtonSecondary,
	ButtonAlert
} from '../../components';
import Caution from '../Icons/Caution';

const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin: 0 1em;
	padding: 0 0 50px;

	button {
		text-transform: uppercase;
		min-width: 18em;
		margin: 0 0.5em;
		${below.desktop`
			min-width: 85px;
		`}
	}
`;

const ModalText = styled.p`
	font-size: 14px;
	line-height: 1.7em;
	text-align: center;
	padding: 40px 30px;
	box-sizing: border-box;

	> svg {
		display: block;
		position: relative;
		width: 100px;
		height: 100px;
		color: ${colors.red};
		margin: 0 auto 25px;
	}
`;


type Props = {
	closeClick: Function,
	confirmClick: Function,
	cancelClick: Function,
	header_text: string,
	body_text?: string,
};

export const RemoveConfirmationModal = ({
	closeClick,
	confirmClick,
	cancelClick,
	header_text,
	body_text,
}: Props) => (
	<ModalContainer header_text={header_text} onClick={closeClick}>
		<ModalText>
			<Caution />
			{body_text}
		</ModalText>
		<ButtonWrapper>
			<ButtonSecondary onClick={cancelClick}>
				NO, KEEP THIS LEAGUE
			</ButtonSecondary>
			<ButtonAlert onClick={confirmClick}>
				YES, REMOVE THIS LEAGUE
			</ButtonAlert>
		</ButtonWrapper>
	</ModalContainer>
);

export default RemoveConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/Modal/RemoveConfirmationModal.js